<app-section-loader [loading]="loading"></app-section-loader>
<div class="mContent__header bg-primary py-3 px-5">
  <h1 class="text-white mb-1">Yearly Plan Details</h1>
  <div class="mControls">
    <div class="input-group mr-auto align-items-center">
      <span class="h2 text-white">{{ curriculum?.curriculum_name }}</span>
    </div>
    <div class="mControls__right">
      <div class="input-group">
        <button mat-raised-button (click)="navigateBack()">
          <mat-icon>done</mat-icon> Done
        </button>
      </div>
    </div>
  </div>
</div>
<hr class="m-0">
<div class="scroll flex-fill overflow-auto py-3 px-5">
  <div class="container container-md px-0">
    <div class="row mx-n4 mt-4">

      <div class="col-lg-12 px-2 mb-3">
        <div class="card">
          <div class="card-header">General</div>
          <div class="card-body">
            <ul class="list-unstyled form-lr">
              <li>
                <span class="form-lr__left">Name</span>
                <span class="form-lr__right">{{ curriculum?.curriculum_name || '—' }}</span>
              </li>
              <li>
                <span class="form-lr__left">Description</span>
                <span class="form-lr__right">{{ curriculum?.description || '—' }}</span>
              </li>
              <li>
                <span class="form-lr__left">Finished</span>
                <span class="form-lr__right">{{ curriculum?.is_finished ? 'Yes' : 'No' }}</span>
              </li>
              <li>
                <span class="form-lr__left">Total Lesson Plans</span>
                <span class="form-lr__right">{{ allCurriculumLessonPlans?.length || 0 }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-lg-12 px-2 mb-3">
        <div class="card">
          <div class="card-header d-flex align-items-center justify-content-between">
            <span>Lesson Plans</span>
            <div class="d-flex align-items-center">

              <mat-form-field appearance="outline" class="mb-0 mr-2 no-error" style="width: 180px;">
                <mat-label>Filter Grades</mat-label>
                <mat-select multiple [(ngModel)]="selectedCurriculumGradeIds"
                  (selectionChange)="filterCurriculumLessonPlans()">
                  <mat-option *ngFor="let grade of availableCurriculumGrades" [value]="grade.id">
                    {{ grade.grade_level }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="mb-0 mr-2 no-error"
                [class.mat-form-field-invalid]="duplicateLessonPlanError" style="width: clamp(280px, 32vw, 560px);">
                <mat-label>Select Lesson Plan</mat-label>

                <mat-select [(ngModel)]="selectedLessonPlanId" (selectionChange)="duplicateLessonPlanError = false"
                  panelClass="lesson-plan-select-panel">
                  <mat-option>
                    <ngx-mat-select-search [formControl]="lessonPlanSearchControl"
                      [noEntriesFoundLabel]="'No matching lesson plan found'" placeholderLabel="Search lesson plan">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let lp of filteredLessonPlans" [value]="lp.id">
                    <span class="lesson-plan-option-text">
                      {{ lp.lesson_plan_number }} — {{ lp.grade_id?.grade_level }} — {{ lp.lesson_plan_name }}
                    </span>
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="duplicateLessonPlanError">
                  Lesson plan is already added to this Yearly Plan
                </mat-error>
              </mat-form-field>
              <button mat-raised-button color="primary" class="mr-2" [disabled]="!selectedLessonPlanId"
                (click)="addLessonPlan()">
                Add
              </button>
              <button mat-raised-button (click)="createLessonPlan()">
                Create New
              </button>
            </div>
          </div>
          <div class="card-body p-0">
            <table *ngIf="lessonPlans?.length > 0" class="table no-wrap m-0 table--hover">
              <thead>
                <tr>
                  <th scope="col">Lesson Number</th>
                  <th scope="col">Lesson Name</th>
                  <th scope="col">Grade Level</th>
                  <th scope="col" class="table-head-empty-label">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let lpc of lessonPlans">
                  <td class="cursor-pointer" (click)="goToLessonPlan(lpc.lesson_plan_id?.id)">
                    {{ lpc.lesson_plan_id?.lesson_plan_number }}
                  </td>
                  <td class="cursor-pointer" (click)="goToLessonPlan(lpc.lesson_plan_id?.id)">
                    {{ lpc.lesson_plan_id?.lesson_plan_name }}
                  </td>
                  <td>{{ lpc.lesson_plan_id?.grade_id?.grade_level }}</td>
                  <td class="text-nowrap">
                    <a class="cursor-pointer icon-btn mr-2 d-inline-block"
                      (click)="editLessonPlan(lpc.lesson_plan_id?.id)" aria-label="Edit">
                      <mat-icon matTooltip="Edit lesson plan">edit</mat-icon>
                    </a>
                    <a class="cursor-pointer icon-btn d-inline-block" (click)="removeLessonPlan(lpc.id)"
                      aria-label="Remove">
                      <mat-icon matTooltip="Remove from Yearly Plan">delete</mat-icon>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <div *ngIf="!lessonPlans?.length" class="p-4 text-center text-muted">
              No lesson plans added yet. Use the selector above to add one.
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>